// extracted by mini-css-extract-plugin
export default {"input":"GzIwk","checkedCheckbox":"tqrrZ","wrapper":"_55pxf","checkbox":"DCN63","policy":"_4TK3M","labelContainer":"iBTR4","checkboxLabel":"_19zOG","checkboxWrapper":"y2pIq"};